
import { s, Shape } from "@kosmod/pancake";
import { idDef } from "@kosmod/kit";

import { TheatreMatrix4, TheatrePosition } from "./position";
import { PhysicsDiceID } from "./dice";
import { ToolStateRaw } from "./tools";

export type PlayerInScene = Shape.Type.Of<typeof PlayerInScene>;
export const PlayerInScene = s.o({
  id: idDef,

  cursor: s.optional(TheatrePosition.def),
  tool: s.optional(ToolStateRaw),
  dice: s.optional(s.a(s.t([PhysicsDiceID, TheatreMatrix4])))
});
